; (function ($, _, root) {
    var common = require('../common');
    
    var App = {
        _timestamp: new Date().valueOf(),
        
        getSDK: function () {
            return $.ajax({
                // 外网每次发布时cdn都会清缓存，内网用时间戳
                url: common.env === 'production' ? 'http://static1.ssp.xunlei.com/js/sdk.min.js' : 'http://test.sdk.ssp.xunlei.com/sdk.min.js?v=' + App._timestamp,
                dataType: 'script',
                timeout: 7000,
                cache: true
            });
        },
        
        /**
         * 获得广告位ID
         * @param positionId 三种形式 
         * 一种 "内网ID/外网ID" 
         * 一种内网ID、外网ID一致
         * 一种数组
         */
        getPositionId: function (param) {
            var splitArray = function (arg) {
                var inNetPid, outNetPid;
                var _arr = arg.split('/');
                if (_arr.length >= 2) {
                    inNetPid = _arr[0];
                    outNetPid = _arr[1];
                } else {
                    inNetPid = outNetPid = _arr[0];
                }
                return (common.env == 'production' ? outNetPid : inNetPid);
            };
            if (typeof param == 'string') {
                return splitArray(param);
            } else if (typeof param == 'number') {
                return param;
            } else if (param instanceof Array) {
                var arr = [];
                for (var i = param.length; i--;) {
                    var _pid = param[i].positionId;
                    if (typeof _pid == 'string') {
                        var _val = splitArray(_pid);
                        arr.push({ positionId: _val });
                    } else if (typeof _pid == 'number') {
                        arr.push({ positionId: _pid });
                    }
                }
                return arr;
            }
        },
        
        load: function (positionID, callback) {
            var handler = function (sdk) {
                var _positionId = App.getPositionId(positionID);
                sdk.load({
                    positionId: _positionId,
                }, function (order) {
                    callback(order);
                });
            };
            
            App.getSDK()
                .then(function () {
                    if (!root._xl_ssp_sdk) {
                        return;
                    }
                    
                    root._xl_ssp_sdk.debug = common.env == 'production' ? false : true;
                    handler(root._xl_ssp_sdk);
                }, function () {
                    callback(null);
                });
        },
        
        loadMore: function (positionIDs, callback) {
            var handler = function (sdk) {
                var _positionId = App.getPositionId(positionIDs);
                sdk.loadMore(_positionId, function (orders) {
                    callback(orders);
                });
            };

            if (root._xl_ssp_sdk) {
                handler(root._xl_ssp_sdk);
            } else {
                App.getSDK()
                    .then(function () {
                        if (!root._xl_ssp_sdk) {
                            return;
                        }
                        
                        root._xl_ssp_sdk.debug = common.env === 'production' ? false : true;
                        handler(root._xl_ssp_sdk);
                    });
            }
        }
    };
    
    if (typeof exports === 'object') {
        module.exports = App;
    }
})(jQuery, _, window);


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/advertisement/base.js
// module id = 42
// module chunks = 2 6 10 12